/**
 * LandingButton.tsx — Carbon-lignende knapp som lenke (primær / tertiær)
 *
 * Native CSS med var(--cds-*) (se landing-button.module.css). Rendres som
 * <a> for anker og som next/link for interne ruter.
 */

import Link from 'next/link';
import { ArrowDown, ArrowRight } from '@carbon/icons-react';
import type { LandingLink } from '@/types/landing';
import styles from './landing-button.module.css';

interface LandingButtonProps {
  link: LandingLink;
  kind?: 'primary' | 'tertiary';
  /** «down» for knapper som scroller til en seksjon på siden (som ibm.com) */
  icon?: 'right' | 'down';
}

export default function LandingButton({ link, kind = 'primary', icon = 'right' }: LandingButtonProps) {
  const Icon = icon === 'down' ? ArrowDown : ArrowRight;
  const className = kind === 'primary' ? styles.primary : styles.tertiary;
  const content = (
    <>
      <span>{link.label}</span>
      <Icon size={20} aria-hidden />
    </>
  );

  // Anker og eksterne protokoller (mailto:) som vanlig <a>, interne ruter som next/link
  if (link.href.startsWith('#') || link.href.includes(':')) {
    return (
      <a href={link.href} className={className}>
        {content}
      </a>
    );
  }
  return (
    <Link href={link.href} className={className}>
      {content}
    </Link>
  );
}
